<section class="container">
    <div autofocus class="search-contents">
        <form [formGroup]="identificatorForm" (ngSubmit)="loadCertificates()" (keydown.enter)="onEnter($event)">
            <div class="row-content">
                <mat-form-field class="col-4 line">
                    <mat-label>{{ 'businessTexts.fromValidityDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="startDate" formControlName="startDate"
                        [matDatepickerFilter]="filterStartDate">
                    <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                    <button *ngIf="identificatorForm.get('startDate')?.value" matSuffix mat-icon-button
                        (click)="clearField('startDate')">
                        <cqes-icon icon="close"></cqes-icon>
                    </button>
                    <mat-datepicker #startDate></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-4 line">
                    <mat-label>{{ 'businessTexts.untilExpirationDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="endDate" formControlName="endDate"
                        [matDatepickerFilter]="filterEndDate">
                    <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                    <button *ngIf="identificatorForm.get('endDate')?.value" matSuffix mat-icon-button
                        (click)="clearField('endDate')">
                        <cqes-icon icon="close"></cqes-icon>
                    </button>
                    <mat-datepicker #endDate></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="row-content">
                <mat-form-field>
                    <input matInput placeholder="{{'businessTexts.name' | translate}}" formControlName="name"
                        type="text">
                    <button *ngIf="identificatorForm.get('name')?.value" matSuffix mat-icon-button
                        (click)="clearField('name')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <div>
                    <!-- <mat-form-field>
                        <input matInput placeholder="{{'businessTexts.identificator' | translate}}"
                            formControlName="identificator" type="text">
                        <button *ngIf="identificatorForm.get('identificator')?.value" matSuffix mat-icon-button
                            (click)="clearField('identificator')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field> -->
                    <mat-form-field>
                        <input matInput placeholder="{{'businessTexts.identificator' | translate}}"
                            formControlName="identificator" type="text">

                        <button *ngIf="identificatorForm.get('identificator')?.value" matSuffix mat-icon-button
                            (click)="clearField('identificator')">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-error *ngIf="identificatorForm.get('identificator')?.hasError('pattern')
    && (identificatorForm.get('identificator')?.touched || identificatorForm.get('identificator')?.dirty)">
                            {{'businessTexts.Must10digits' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>


                <mat-form-field>
                    <input matInput placeholder="{{'businessTexts.email' | translate}}" formControlName="email"
                        type="email">
                    <button *ngIf="identificatorForm.get('email')?.value" matSuffix mat-icon-button
                        (click)="clearField('email')">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-error
                        *ngIf="identificatorForm.get('email')?.hasError('email') || identificatorForm.get('email')?.hasError('pattern')">
                        {{'businessTexts.invalidEmail' | translate}}
                    </mat-error>
                </mat-form-field>
                <div class="text-error-phone">
                    <mat-form-field>
                        <input matInput placeholder="{{'businessTexts.phone' | translate}}" formControlName="phone"
                            type="tel">
                        <button *ngIf="identificatorForm.get('phone')?.value" matSuffix mat-icon-button
                            (click)="clearField('phone')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-error *ngIf="identificatorForm.get('phone')?.hasError('pattern') 
             && (identificatorForm.get('phone')?.touched || identificatorForm.get('phone')?.dirty)"
                        class="text-error-phone">
                        {{'businessTexts.phoneValidatorError' | translate}}
                    </mat-error>
                </div>
            </div>
            <div>
                <mat-error *ngIf="shouldShowIdentificatorError()">
                    {{ 'businessTexts.identificatorRequired' | translate }}
                </mat-error>
            </div>
            <div class="row-content-right">
                <button class="mat-mdc-raised-button action-button" type="button" (click)="resetFilters()">
                    {{'historyTexts.resetFilters' | translate}}
                </button>
                <button mat-raised-button type="submit" [disabled]="!isFormValid() || isFormEmpty()">{{'businessTexts.search' |
                    translate}}</button>
                <button mat-button (click)="exportExcel()" [disabled]="!hasData() || isFormEmpty()" type="button"
                    class="mat-mdc-raised-button">{{
                    'businessTexts.downloadExcelIdentification' | translate }}</button>
            </div>

        </form>
    </div>
    <div class="spinner-container" *ngIf="loading || isLoading">
        <mat-spinner class="content-box"></mat-spinner>
    </div>
    <div class="message" *ngIf="!hasData() && !isLoading">
        {{'historyTexts.noDocumentsFound' | translate}}
    </div>

    <div class="data-container" [hidden]="!hasData() || isLoading">

        <div>
            <div class="col-md-12">
                <div class="message" *ngIf="!hasData()">
                    {{'businessTexts.identificationTable.noidentificationTable' | translate}}
                </div>
                <div class="data-container">
                    <div class="mat-elevation-z8 table-content">
                        <mat-table [dataSource]="idintificatorDataSource" matSort matSortActive="registrationTime" class="identification-table"
                            multiTemplateDataRows>
                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef="let status">
                                    <div class="status-head"> {{'businessTexts.identificationTable.status' | translate}}
                                    </div>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row">
                                    <div class="cell" [ngSwitch]="row.status">
                                        <div matTooltip="{{'businessTexts.identificationTable.onBoarding' | translate}}"
                                            *ngSwitchCase="'ON_BOARDING'">
                                            <cqes-icon icon="hourglass_empty"
                                                class="text-warning row-status-identification"></cqes-icon>
                                        </div>

                                        <div matTooltip="{{'businessTexts.identificationTable.eidExpired' | translate}}"
                                            *ngSwitchCase="'EID_EXPIRED'">
                                            <cqes-icon icon="hourglass_empty"
                                                class="text-danger row-status-identification"></cqes-icon>
                                        </div>
                                        <div matTooltip="{{'businessTexts.identificationTable.registrationRequestInProgress' | translate}}"
                                            *ngSwitchCase="'REGISTRATION_REQUEST_IN_PROGRESS'"><cqes-icon
                                                icon="hourglass_empty"></cqes-icon>
                                        </div>
                                        <div matTooltip="{{'businessTexts.identificationTable.CQESinProgress' | translate}}"
                                            *ngSwitchCase="'CQES_IN_PROGRESS'"><cqes-icon icon="hourglass_empty"></cqes-icon>
                                        </div>
                                        <div matTooltip="{{'businessTexts.identificationTable.eidProgress' | translate}}"
                                            *ngSwitchCase="'EID_IN_PROGRESS'"><cqes-icon icon="hourglass_empty"></cqes-icon>
                                        </div>
                                        <div matTooltip="{{'businessTexts.identificationTable.eidFinalized' | translate}}"
                                            *ngSwitchCase="'EID_FINALIZED'">
                                            <cqes-icon icon="done" iconClass="text-success"></cqes-icon>
                                        </div>
                                        <span *ngSwitchDefault>{{ row.status }}</span>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="registrationTime">
                                <mat-header-cell mat-sort-header *matHeaderCellDef="let registrationTime"
                                    class="registration-time-column">
                                    {{'businessTexts.identificationTable.registrationTime' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row" class="registration-time-column">
                                    <div class="cell">
                                        {{row.registrationTime}}
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="clientIdentifierType">
                                <mat-header-cell mat-sort-header *matHeaderCellDef="let clientIdentifierType">
                                    {{'businessTexts.identificationTable.clientIdentifierType' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row">
                                    <div class="cell">
                                        {{'businessTexts.identificationTable.egn' | translate}}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="clientIdentifier">
                                <mat-header-cell mat-sort-header *matHeaderCellDef="let identificator">
                                    {{'businessTexts.identificator' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row">
                                    <div class="cell">
                                        {{row.clientIdentifier | maskEgn}}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="name">
                                <mat-header-cell mat-sort-header *matHeaderCellDef="let name">
                                    {{'businessTexts.identificationTable.name' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row">
                                    <div class="cell">
                                        <span>{{ getName(row.name) }}</span>
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="email">
                                <mat-header-cell mat-sort-header #email id="email" *matHeaderCellDef="let email">
                                    {{'businessTexts.email' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row">
                                    <div class="cell" matTooltip=" {{row.email}}">
                                        {{row.email}}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="phone">
                                <mat-header-cell mat-sort-header #phone id="phone" *matHeaderCellDef="let phone">
                                    {{'businessTexts.phone' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row">{{row?.phone}}

                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell class="header-align-right" *matHeaderCellDef>
                                    {{ 'businessTexts.identificationTable.actions' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row">
                                    <ng-container
                                        *ngIf="row.status === 'EID_FINALIZED'">
                                        <span [matMenuTriggerFor]="docs" class="action">
                                            <button mat-icon-button color="primary">
                                                <cqes-icon icon="menu"></cqes-icon>
                                            </button>
                                        </span>

                                        <mat-menu #docs="matMenu">
                                            <div>
                                                <button mat-menu-item
                                                    (click)="downloadUEI(row.callbackId, row.clientIdentifier)"
                                                    *ngIf="row.status === 'EID_FINALIZED'">
                                                    <cqes-icon icon=" settings"></cqes-icon>
                                                    {{'businessTexts.downloadUEI' | translate}}
                                                </button>
                                            </div>
                                        </mat-menu>
                                    </ng-container>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;" class="expand-element-row">
                            </mat-row>
                        </mat-table>

                    </div>

                </div>
            </div>
        </div>

    </div>
</section>